import { combineReducers } from 'redux';

// Reducers
import animationStage from './animation-stage';
import chooseABacteriaStatus from './choose-a-bacteria-status';
import activeBacteria from './active-bacteria';
import animationStatus from './animation-status';
import activeFeature from './active-feature';
import featureMap from './feature-map';
import choiceHover from './choice-hover';
import activePetri from './active-petri-dish';
import returning from './returning';

const allReducers = combineReducers({
    animationStage,
    chooseABacteriaStatus,
    activeBacteria,
    animationStatus,
    activeFeature,
    featureMap,
    choiceHover,
    activePetri,
    returning
});

export default allReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js